import Vue from "vue"

import loading from "./loading"

const $load  =  Vue.extend(loading);

let $dom,$child;    //记录节点、子节点

$load.newInstance = (option)=>{

    //移除节点
    if($dom && $child){$dom.removeChild($child)}

    let $visible = JSON.parse(JSON.stringify(option.$data.visible));
        option.$data.visible = false;

    let instance = new $load({
        data: option.$data,
        methods:option.$methods
    }).$mount();


    //父节点
    if(option.$data.mountDOM){

        $dom = option.$data.mountDOM;

    }else{

        $dom = document.body;
    }

    //子节点
    $child = instance.$el;

    $dom.appendChild(instance.$el);

    Vue.nextTick(() => {
        instance.visible = $visible
    });

    return instance;

}


export default {
    loading:$load.newInstance
}